import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { UserProfileGetResponse } from './user-profile-get-response';
import { UserProfileRequest } from './user-profile-request';

@Injectable({ providedIn: 'root' })
export class UserProfileApi {
  constructor(private afs: AngularFirestore) {}

  get(key: string): Observable<UserProfileGetResponse | undefined> {
    const profileDoc = this.afs.doc<UserProfileGetResponse>(
      `/user_profiles/${key}`,
    );

    return profileDoc.valueChanges();
  }

  set(key: string, userProfileRequest: UserProfileRequest): Promise<void> {
    const profileDoc = this.afs.doc<UserProfileRequest>(
      `/user_profiles/${key}`,
    );
    return profileDoc.set(userProfileRequest);
  }

  update(key: string, userProfileRequest: UserProfileRequest): Promise<void> {
    const profileDoc = this.afs.doc<UserProfileRequest>(
      `/user_profiles/${key}`,
    );
    return profileDoc.update(userProfileRequest);
  }
}
